const en = {
  sourceInfo: {
    paragraph1:
      "SOURCE ry is TAMK's information and communication technology student association. The association was founded in 2016 and registered as an association a year later. The most visible part of our association is our clubroom, which can be found at the end of the A-wing clubroom corridor, in room A0-35.",
    paragraph2:
      "SOURCE's purpose is to strengthen the TiTe network and share information about the opportunities in our field. SOURCE organizes events such as sauna and board game nights for its members, as well as a weekly sports shift. Our most significant events include the traditional TiTeLAN parties.",
    paragraph3:
      "SOURCE works closely with Tamko, TIRO ry, and other TAMK student associations by participating in the organization of events.",
    paragraph4:
      "All students are welcome to join the club regardless of their program. However, company visits are aimed at IT students.",
  },
  partnersTitle: "Our Partners",
  nav: {
    frontPage: "Front page",
    membership: "Membership",
    events: "Events",
    titelan: "TiTeLAN",
    iotSeminaari: "IoT-Seminar",
    suggestions: "Suggestions",
    contact: "Contact",
    association: "Association",
    board: "Board",
    partners: "Partners",
    products: "Products",
    rules: "Rules",
  },
  footerInfo: {
    address1: "Club room: Wing-A, basement floor A0-35",
    address2:
      "To find the club room, walk past every club room in the basement floor, walk through the door that comes straight ahead in the corridor and walk almost to the outside door.",
  },
  happeningNow: "Happening now!",
  time: {
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
  },
  roles: {
    chairperson: "Chairperson",
    viceChairperson: "Vice Chairperson",
    treasurer: "Treasurer",
    secretary: "Secretary",
    secretaryLegacy: "Secretary and Communications",
    socialMediaAndCommunications: "Social Media and Communications",
    eventsCoordinator: "Events Coordinator",
    leisureCoordinator: "Leisure Coordinator",
    membershipAndClubroomCoordinator: "Membership and Clubroom Coordinator",
    externalRelationsCoordinator: "External Relations Coordinator",
    internationalStudentsCoordinator: "International Students Coordinator",
    kopo: "Educational Affairs",
    webmaster: "Webmaster",
    officer: "Officer",
  },
  boardMembers: "Board Members",
  officers: "Officers",
  newBoardDescription:
    "The new board and officers are elected every year at the autumn meeting, and the nomination takes place by attending the meeting and expressing one's willingness at the point in the meeting when the board/officers are being selected.",
  pastBoards: "Past Boards and Officers",
  contactInformation: "Contact Information",
  email: "Email",
  address: "Address",
  harassmentContact: "Harassment Contact",
  harassmentInfo: {
    paragraph1:
      "Everyone has the right to a safe life without any form of harassment. Inappropriate, discriminatory, and offensive speech, behavior, or communication has no place in Tampere University of Applied Sciences or in any other student life.",
    paragraph2:
      "SOURCE's harassment contact person supports and advises students who have experienced harassment. Those who have witnessed harassment can also contact the harassment contact person with questions or concerns, such as discussing procedures. The harassment contact person does not initiate further actions without consent. They do not keep records of those who have contacted them and have complete confidentiality.",
    paragraph3: "Harassment contact can be reached by email",
  },
  eventsDescription:
    "Source ry organizes various events for its members, such as company visits or excursions, various leisure activities, and seminars on the ICT field.",
  leisureActivities: "Leisure Activities",
  leisureActivitiesExamples: "Some of the leisure activities",
  companyEvents: "Company Events",
  companyEventsDesctiption:
    "Different events where students have the opportunity to get to know companies, their developed products/solutions, hear interesting topics about ICT, and spend an evening with company personnel. Such events include",
  events: {
    studentParties: "Student Parties",
    newbiesNight: "Newbies' Night",
    sportShifts: "Sport Shifts",
    titelan: "TiTeLAN",
    boardGameNights: "Board Game Nights",
    other: "Other",
    excursions: "Excursions",
    seminars: "Seminars",
    expos: "Expos",
  },
  // iotSeminarInfo: {
  //   paragraph1:
  //     "The IoT Seminar is a seminar event held at Tampere University of Applied Sciences, which brings together industry companies, experts, and students.",
  //   paragraph2:
  //     "The IoT Seminar delves into various solutions and innovations in the field of science and technology through seminar presentations, and during the day, attendees can visit different company booths and network.",
  // },
  membershipInfo: {
    paragraph1:
      "The annual membership fee for SOURCE is 5€. Membership can be obtained from either a board member or the SOURCE online store. When you purchase a four-year membership at once, you will receive a SOURCE overall patch for free (ask a board member for the patch).",
    paragraph2: "Membership benefits include:",
    paragraph3:
      "The SOURCE clubroom can be found in room A0-35 on the basement floor of the Kuntokatu A-wing (walk along the clubroom corridor almost to the exit and turn left). The clubroom is a place where you can almost always find support for your studies, and it also has games.",
    paragraph4:
      "In addition, SOURCE participates in educational policy alongside TAMKO and the information and communication technology program.",
  },
  membershipBenefits: {
    events: "participate in events meant for members, such as sauna evenings",
    excursions: "join company excursions",
    coffeTea: "free coffee and tea in the clubroom",
    votingRight: "voting rights at the autumn and spring meetings",
  },
  becomeMember: "Become a member",
  pageNotFound: "Page not found",
  pageNotFoundExplanation:
    "Judging by the typos, you've already graduated as an engineer!",
  backToMain: "Back to main page",
  corporatePartnershipTitle: "Corporate Partnership",
  companyPartnership: {
    intro:
      "SOURCE ry's goal for company collaboration is to bring students closer to businesses. Collaboration with companies provides a strong foundation for students to get to know companies, learn about the industry, and network. For businesses, collaboration with SOURCE ry ensures visibility among TAMK's IT students and the opportunity to connect with future industry professionals.",
    diverseFlexible:
      "Company collaboration is diverse and flexible. We aim to find the best possible solution for both parties on a case-by-case basis. Below, you'll find more details about the possibilities.",
    jobPostings: {
      title: "Job Postings",
      description:
        "SOURCE ry offers companies the opportunity to send job postings and other announcements to its members as agreed. The package includes the company's logo on SOURCE ry's homepage and a brief description of the company on the Partners page.",
    },
    excursions: {
      title: "Excursions",
      description:
        "Excursions are popular events among SOURCE ry's members. They provide students with the best opportunity to visit an interesting company and learn about its operations. For companies, excursions are an excellent opportunity to get to know IT students and future professionals.",
    },
    guestLectures: {
      title: "Guest Lectures",
      description:
        "Guest lectures are a great way to share professional expertise with students. Students are always interested in industry practices and technologies. For guest lectures, SOURCE ry can reserve facilities at TAMK.",
    },
    // iotSeminar: {
    //   title: "IoT Seminar",
    //   description:
    //     "The IoT Seminar is an annual event held at Tampere University of Applied Sciences, bringing together industry companies, experts, and students. The event is organized by SOURCE ry, and the proceeds from the event are directed towards developing the IoT Seminar and SOURCE ry's activities. Companies can participate by securing an exhibition booth and/or delivering a presentation. Booth prices typically range from 150-250€ for a 2-day event, and presentations are free for companies.",
    // },
    overallsAds: {
      title: "Overalls Ads",
      description:
        "Overalls ads offer companies a great opportunity to gain visibility among students. SOURCE ry provides companies with the opportunity to purchase ad space on student overalls. The prices for ad spaces vary depending on location and size, ranging from 500€ to 1000€. The proceeds from overall ads are used to purchase coveralls and to organize activities for the members.",
    },
  },
  webpage: "Webpage",
  rules: "Rules",
  clubRoomSuggestions: {
    paragraph1: "Tell us what the club room is missing!",
    paragraph2:
      "Fill out the form behind the link below and record what you would like the board to purchase for the club room.",
  },
  clubRoomAquisitions: "Club room acquisitions",
  companySuggestions: {
    paragraph1:
      "Do you have a specific company in mind where you would like to work or simply visit to see what it's like?",
    paragraph2: "Submit your own excursion suggestion to us!",
    paragraph3: "Which company would you like to see?",
  },
  excursionSuggestions: "Excursion suggestions",
  nextTitelan: "Next TiTeLAN",
  tickets: "Tickets",
  titelanInfo: {
    title: "TiTeLANIt is a LAN event held in the spring and autumn.",
    description:
      "TiTeLAN originated in the autumn of 2008 when there was no dedicated gaming event at TAMK. Throughout its long history, Titelanit has been popular in terms of the number of participants, and various gaming tournaments have been organized during the LAN parties. The established venue for TiTeLAN is TAMK's sports hall, although, on a few occasions, the Demola in downtown Tampere has also been used. The event has been held continuously every year, except for a break during the pandemic.",
  },
  pastTitelans: "Past TiTeLANs",
  location: "Location",
  tournaments: "Tournaments",
  associationInfo: {
    paragraph1:
      "SOURCE ry is TAMK's information and communication technology subject club. The club was established in 2016. We registered as an association a year later. The most visible part of our club is our own clubroom, which can be found at the end of the A-wing clubroom corridor, in room A0-35.",
    paragraph2:
      "SOURCE's purpose is to consolidate the TiTe network and share information about the opportunities in our field. SOURCE organizes various events for its members, including sauna and board game nights, as well as a weekly sports shift. Our most significant events include the traditional TiTeLANit LAN party.",
    paragraph3:
      "SOURCE collaborates closely with Tamko, TIRO ry, and other TAMK clubs by participating in event organization.",
    paragraph4:
      "All students are welcome to join the club, regardless of their study program. However, company visits are primarily aimed at information technology students.",
  },
};

export default en;
